define.alias("shared/components/shared/pre-boarding/index", "preview-grid/components/shared/pre-boarding/index");